module.exports = __webpack_public_path__ + "img/1_027.caaa0b26.jpg";